import {Component,type ErrorInfo,type ReactNode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './app/App';
import {createAppRepository} from './services/repository';
import '@fontsource-variable/inter';
import '@fontsource-variable/roboto-slab';
import './styles/app.css';
import './styles/react.css';

const repository=createAppRepository();
class Boundary extends Component<{children:ReactNode},{error:string}>{
  state={error:''};
  static getDerivedStateFromError(error:Error){return {error:error.message};}
  componentDidCatch(error:Error,info:ErrorInfo){console.error('Error de presentación',error,info.componentStack);}
  render(){return this.state.error?<main><section className="card"><h1>No fue posible mostrar esta pantalla</h1><p>Los registros almacenados no se han eliminado.</p><p className="muted">{this.state.error}</p><button className="btn ghost" onClick={()=>location.reload()}>Volver a cargar</button><button className="btn ghost" onClick={()=>void import('./exports').then(module=>module.downloadBackup(repository.getSnapshot().state))}>Descargar copia local</button></section></main>:this.props.children;}
}
createRoot(document.getElementById('root')!).render(<Boundary><App repository={repository}/></Boundary>);
if(import.meta.env.PROD && 'serviceWorker' in navigator){
  window.addEventListener('load',()=>{void navigator.serviceWorker.register('/service-worker.js').catch(error=>console.error('No se pudo activar el modo sin conexión',error));});
}
